// Spark / includes/shelf - обвязка pcard-полок (перенос CAROUSEL ARROWS
// из макета): стрелки с показом по позиции скролла, шаг = ширина карточки,
// драг мышью с отключением snap. Плюс драг для горизонтальных сеток
// (cstory-grid и будущие browse-track/blog-grid).
// Потребители: index.js; catalog.js подключит при переносе полок каталога.

export function initShelfCarousels( root ) {

    ( root || document ).querySelectorAll('.pcard-carousel').forEach( ( carousel ) => {

        if( carousel.__shelfInit )
            return;

        carousel.__shelfInit = true;

        const track  = carousel.querySelector('.pcard-track');
        const arrowL = carousel.querySelector('.pcard-arrow-l');
        const arrowR = carousel.querySelector('.pcard-arrow-r');

        if( ! track || ! arrowL || ! arrowR )
            return;

        // базовая позиция после того, как браузерный snap устаканится
        let homePos = 0;

        function updateArrows() {
            const sl        = track.scrollLeft;
            const maxScroll = track.scrollWidth - track.clientWidth;
            arrowL.classList.toggle( 'show', sl > homePos + 10 );
            arrowR.classList.toggle( 'show', maxScroll - sl > 10 );
        }

        setTimeout( () => {
            homePos = track.scrollLeft;
            updateArrows();
        }, 200 );

        let tick = false;

        track.addEventListener( 'scroll', () => {
            if( tick )
                return;
            tick = true;
            requestAnimationFrame( () => {
                updateArrows();
                tick = false;
            } );
        } );

        function step() {
            const card = track.querySelector('.pcard');
            return card
                ? card.offsetWidth + 12
                : 280;
        }

        arrowL.addEventListener( 'click', () => {
            track.scrollBy( { left : -step(), behavior : 'smooth' } );
        } );

        arrowR.addEventListener( 'click', () => {
            track.scrollBy( { left : step(), behavior : 'smooth' } );
        } );

        attachDrag( track, 'a,button,.pcard-cart' );
    } );
}

// драг для горизонтальных сеток без стрелок
export function initGridDrag( root ) {

    ( root || document ).querySelectorAll('.cstory-grid, .browse-track, .blog-grid').forEach( ( el ) => {

        if( el.__dragInit )
            return;

        el.__dragInit  = true;
        el.style.cursor = 'grab';
        attachDrag( el, 'a,button', true );
    } );
}

// общий драг: отключаем snap на время перетаскивания
function attachDrag( el, ignoreSelector, grabCursor ) {

    let isDown  = false;
    let startX  = 0;
    let scrollL = 0;

    function release() {
        if( ! isDown )
            return;
        isDown = false;
        el.classList.remove('dragging');
        el.style.scrollBehavior = '';
        el.style.scrollSnapType = '';
        if( grabCursor )
            el.style.cursor = 'grab';
    }

    el.addEventListener( 'mousedown', ( e ) => {
        if( e.target.closest( ignoreSelector ) )
            return;
        e.preventDefault();
        isDown  = true;
        startX  = e.pageX - el.offsetLeft;
        scrollL = el.scrollLeft;
        el.classList.add('dragging');
        el.style.scrollBehavior = 'auto';
        el.style.scrollSnapType = 'none';
        if( grabCursor )
            el.style.cursor = 'grabbing';
    } );

    el.addEventListener( 'mouseleave', release );
    el.addEventListener( 'mouseup', release );

    el.addEventListener( 'mousemove', ( e ) => {
        if( ! isDown )
            return;
        e.preventDefault();
        const x = e.pageX - el.offsetLeft;
        el.scrollLeft = scrollL - ( x - startX );
    } );
}

// browse-карусель категорий: стрелки листают по 4 карточки
export function initBrowseCarousel( root ) {

    ( root || document ).querySelectorAll('.browse-carousel').forEach( ( carousel ) => {

        if( carousel.__browseInit )
            return;

        carousel.__browseInit = true;

        const track  = carousel.querySelector('.browse-track');
        const arrowL = carousel.querySelector('.browse-arrow-l');
        const arrowR = carousel.querySelector('.browse-arrow-r');

        if( ! track || ! arrowL || ! arrowR )
            return;

        let homePos = 0;

        function updateArrows() {
            const sl        = track.scrollLeft;
            const maxScroll = track.scrollWidth - track.clientWidth;
            arrowL.classList.toggle( 'show', sl > homePos + 10 );
            arrowR.classList.toggle( 'show', maxScroll - sl > 10 );
        }

        setTimeout( () => {
            homePos = track.scrollLeft;
            updateArrows();
        }, 200 );

        let tick = false;

        track.addEventListener( 'scroll', () => {
            if( tick )
                return;
            tick = true;
            requestAnimationFrame( () => {
                updateArrows();
                tick = false;
            } );
        } );

        function step() {
            const card = track.querySelector('.browse-card');
            return card
                ? ( card.offsetWidth + 16 ) * 4
                : 1200;
        }

        arrowL.addEventListener( 'click', () => {
            track.scrollBy( { left : -step(), behavior : 'smooth' } );
        } );

        arrowR.addEventListener( 'click', () => {
            track.scrollBy( { left : step(), behavior : 'smooth' } );
        } );
    } );
}